import { doMutation } from "../../core-module/util/graphqlHelper";

export const importTrainingRegistrationRows = input => {
  const mutation = require("../api/mutation/importTrainingRegistrationRows.gql");
  const variables = { input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.importTrainingRegistrationRows };
    if (error) return { error: JSON.stringify(error) };
  });
};
